import React from 'react';
import Features from './Features';
import Advantages from './Advantages';
import { FAQ } from '../FAQ/faqs';
import Footer from '../Footer';





function InventoryManagement() {
  return (
    <>
<Features docname="Inventory Management"/>
<Advantages docname="Inventory Management"/>
<FAQ category="About Accxchange"/>
<Footer segment="Smarty Home"/>
    </>
  );
}

export default InventoryManagement;
